export const GAME_COMPARISON_PERIODS = {
    YOY: "YearOverYear",
    ROLLING: "RollingPeriod",
};